if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();
        this.details = this.querySelector('details');

        this.elements = {
          shareButton: this.querySelector('button'),
          summary: this.querySelector('summary'),
          closeBtn: this.querySelector('.share-button__close'),
          copyBtn: this.querySelector('.share-button__copy'),
          successMsg: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
          body: this.querySelector('.accordion-body')
        };

        this.urlToShare = this.elements.urlInput?.value || location.href;

        // If device supports native share
        if (navigator.share) {
          this.enableNativeShare();
        } else {
          this.enableFallback();
        }
      }

      enableNativeShare() {
        this.details?.setAttribute('hidden', '');
        this.elements.shareButton?.classList.remove('hidden');

        this.elements.shareButton?.addEventListener('click', () => {
          navigator.share({
            url: this.urlToShare,
            title: document.title
          }).catch((err) => {
            console.warn('Share failed:', err);
          });
        });
      }

      enableFallback() {
        this.details?.addEventListener('toggle', () => this.resetFallbackUI());
        this.elements.copyBtn?.addEventListener('click', () => this.copyToClipboard());
        this.elements.closeBtn?.addEventListener('click', () => this.closeDetails());
      }

      resetFallbackUI() {
        if (!this.details.open) {
          this.elements.successMsg?.classList.add('hidden');
          this.elements.successMsg.textContent = '';
          this.elements.urlInput?.classList.remove('visibility-hidden');
          this.elements.copyBtn?.classList.remove('hidden');
          this.elements.closeBtn?.classList.add('hidden');
          this.elements.summary?.focus();
        }
      }

      closeDetails() {
        this.details.removeAttribute('open');
        this.elements.summary?.setAttribute('aria-expanded', false);
        this.elements.body?.removeAttribute('style'); // optional: in case any animation modifies it
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMsg?.classList.remove('hidden');
          this.elements.successMsg.textContent = window.accessibilityStrings?.shareSuccess || 'Link copied!';
          this.elements.urlInput?.classList.add('visibility-hidden');
          this.elements.copyBtn?.classList.add('hidden');
          this.elements.closeBtn?.classList.remove('hidden');
          this.elements.closeBtn?.focus();
        }).catch(() => {
          alert('Failed to copy. Try manually.');
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) this.elements.urlInput.value = url;
      }
    }
  );
}
